<template>
    <div class="add-form">
        <Form
            ref="addForm"
            :model="form"
            :rules="diyData.rules"
            :label-width="100"
        >
            <FormItem label="支付成功通知" prop="payment">
                <Input
                    v-model="form.payment"
                    placeholder="请输入支付成功通知"
                    style="width: 440px"
                ></Input>
                <div class="tips">*报名成功通知：OPENTM411652945</div>
            </FormItem>
            <FormItem label="邀约成功通知" prop="invite">
                <Input
                    v-model="form.invite"
                    placeholder="请输入邀约成功通知"
                    style="width: 440px"
                ></Input>
                <div class="tips">*预约成功通知：OPENTM410419150</div>
            </FormItem>

        </Form>
        <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    </div>
</template>

<script>
import {apiGetSystem, apiSetSystem} from '@/api/organization';

export default {
    name: 'add-form',
    components: {
    },
    data() {
        return {
            query: {},
            search: {},
            diyDom: {},
            // 表单数据
            form: {
                payment: '', // 支付模板
                invite: '', // 邀约模板
            },
            diyData: {
                rules: {
                }
            },
            apiData: {}
        };
    },
    computed: {},
    methods: {
        // 获取配置
        getSettings() {
            this.$store.commit('setSpinShow', true);
            apiGetSystem(this.query.id,'groupon_template_message').then(res => {
                this.form.payment = res.payment || ''
                this.form.invite = res.invite || ''
            }).finally(() => this.$store.commit('setSpinShow', false));
        },

        submit() {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    apiSetSystem(this.query.id,'groupon_template_message', {
                        groupon_template_message: this.form
                    }).then(() => {
                        this.$Message.success('保存成功');
                        this.getSettings();
                    });
                }
            });
        }
    },
    mounted() {
        this.query = this.$route.query;
        this.getSettings();
    }
};
</script>

<style scoped lang="less">
.add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 19px;
        margin-bottom: 10px;
    }
}
</style>
